<template>
  <div class="col-md-3">
    <form-group-select
      v-if="options"
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="options"
      :data-vv-as="label"
      placeholder="Selecione"
      @input="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-receber-token",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: {
      type: Boolean,
      default: true
    },
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  asyncComputed: {
    options() {
      return [
        { value: "email", text: "E-mail" },
        { value: "sms", text: "SMS" },
        { value: "whatsapp", text: "Whatsapp" }
      ];
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/ReceberToken.vue